import {
  Action, ActionProps, FormHandlers, Portal, useModal,
} from '@doveit/bricks';
import React from 'react';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { JobApplication } from '../../../providers/api/dtos';
import UpdateJobApplication, { UpdateJobApplicationProps } from '../update-job-application/UpdateJobApplication';

export type UpdateJobApplicationActionProps = {
  disabled?: boolean,
  onSuccess?: (jobApplication: JobApplication) => void,
  children?: ({ disabled, openUpdateModal }: { disabled: boolean, openUpdateModal?: VoidFunction }) => React.ReactNode,
} & Omit<UpdateJobApplicationProps, 'formRef'> & Pick<ActionProps, 'size'>;

const UpdateJobApplicationAction: React.FC<UpdateJobApplicationActionProps> = ({
  jobApplication,
  hiddenFields,
  disabled = false,
  size = 'S',
  onSuccess,
  children,
}) => {
  const upsertInvoiceModal = useModal();
  const formRef = React.useRef<FormHandlers>(null) as React.MutableRefObject<FormHandlers>;

  const openUpdateModal = React.useCallback(() => {
    upsertInvoiceModal.open();
  }, [upsertInvoiceModal]);

  const onInternalSuccess = React.useCallback((savedJobApplication: JobApplication) => {
    upsertInvoiceModal.close();
    onSuccess?.(savedJobApplication);
  }, [upsertInvoiceModal, onSuccess]);

  const submitForm = React.useCallback(() => {
    formRef.current?.handleSubmit();
  }, []);

  return (
    <>
      {children
        ? children({
          disabled,
          openUpdateModal: disabled
            ? undefined
            : openUpdateModal,
        })
        : (
          <Action
            aria-label="Azione per modificare la candidatura"
            label="Modifica"
            onClick={openUpdateModal}
            disabled={disabled}
            size={size}
          />
        )}
      <Portal>
        <SimpleModal
          {...upsertInvoiceModal}
          title="Modifica candidatura"
          footer={(
            <Action
              label="Modifica"
              color="primary"
              emphasis="high"
              aria-label="Modifica la candidatura"
              onClick={submitForm}
            />
          )}
        >
          <UpdateJobApplication
            jobApplication={jobApplication}
            innerRef={formRef}
            onSuccess={onInternalSuccess}
            hiddenFields={hiddenFields}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};

export default UpdateJobApplicationAction;
